

import { BaseEntity } from '@m4u-angular/base/entities/BaseEntities';

export class PaymentRequestParams extends BaseEntity 
{   
    public RegistrationID: number; 
    public PrivatePaymentRequestID: string; 
    public ClientName: string;  
	
}


